<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="load">刷新</el-button>
      <el-button type="primary" @click="openCreate">新增账号</el-button>
    </div>
    <el-table :data="rows" border stripe v-loading="loading" style="margin-top: 12px">
      <el-table-column prop="username" label="账号" width="140" />
      <el-table-column prop="displayName" label="名称" width="140" />
      <el-table-column prop="roleName" label="角色" width="120" />
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="s">
          <el-tag :type="s.row.status === 1 ? 'success' : 'info'">{{ s.row.status === 1 ? '启用' : '禁用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="170">
        <template slot-scope="s">{{ s.row.createdAt | formatDateTime }}</template>
      </el-table-column>
      <el-table-column label="操作" width="220" fixed="right">
        <template slot-scope="s">
          <el-button type="text" @click="toggle(s.row)">{{ s.row.status === 1 ? '禁用' : '启用' }}</el-button>
          <el-button type="text" @click="openEdit(s.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="userDlg"
      width="480px"
      :close-on-click-modal="false"
      @closed="onDialogClosed"
    >
      <el-form ref="userFormRef" :model="userForm" :rules="userRules" label-width="88px">
        <el-form-item label="账号" prop="username">
          <el-input v-model="userForm.username" :disabled="isEdit" autocomplete="username" placeholder="登录账号" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="userForm.password"
            type="password"
            :placeholder="isEdit ? '留空表示不修改密码' : '初始密码'"
            autocomplete="new-password"
          />
        </el-form-item>
        <el-form-item label="显示名" prop="displayName">
          <el-input v-model="userForm.displayName" placeholder="可留空，默认与账号相同" />
        </el-form-item>
        <el-form-item label="角色" prop="roleId">
          <el-select v-model="userForm.roleId" placeholder="选择角色" style="width: 100%">
            <el-option v-for="r in roles" :key="r.id" :label="r.name + '（' + r.code + '）'" :value="r.id" />
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="userDlg = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitUser">确定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import http from '../api/http';

export default {
  name: 'PlatformUsersView',
  data() {
    const pwdValidator = (rule, value, callback) => {
      if (this.userDialogMode === 'create') {
        if (!value || !String(value).trim()) {
          callback(new Error('请输入密码'));
          return;
        }
      }
      callback();
    };
    return {
      loading: false,
      submitting: false,
      rows: [],
      roles: [],
      userDlg: false,
      userDialogMode: 'create',
      userForm: {
        id: null,
        username: '',
        password: '',
        displayName: '',
        roleId: null
      },
      userRules: {
        username: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { min: 2, message: '至少 2 个字符', trigger: 'blur' }
        ],
        password: [{ validator: pwdValidator, trigger: 'blur' }],
        roleId: [{ required: true, message: '请选择角色', trigger: 'change' }]
      }
    };
  },
  computed: {
    isEdit() {
      return this.userDialogMode === 'edit';
    },
    dialogTitle() {
      return this.isEdit ? '编辑平台账号' : '新增平台账号';
    }
  },
  mounted() {
    this.loadRoles();
    this.load();
  },
  methods: {
    async loadRoles() {
      const { data } = await http.get('/admin/roles');
      this.roles = data.data || data || [];
    },
    async load() {
      this.loading = true;
      try {
        const { data } = await http.get('/admin/platform-users');
        this.rows = data.data || data || [];
      } catch (e) {
        this.$message.error((e && e.message) || '加载失败');
      } finally {
        this.loading = false;
      }
    },
    async toggle(row) {
      const st = row.status === 1 ? 0 : 1;
      try {
        await http.patch(`/admin/platform-users/${row.id}/status`, { status: st });
        this.$message.success('已更新');
        this.load();
      } catch (e) {
        this.$message.error((e && e.message) || '失败');
      }
    },
    openCreate() {
      this.userDialogMode = 'create';
      this.userForm = {
        id: null,
        username: '',
        password: '',
        displayName: '',
        roleId: null
      };
      this.userDlg = true;
      this.$nextTick(() => {
        if (this.$refs.userFormRef) this.$refs.userFormRef.clearValidate();
      });
    },
    openEdit(row) {
      this.userDialogMode = 'edit';
      this.userForm = {
        id: row.id,
        username: row.username,
        password: '',
        displayName: row.displayName || '',
        roleId: row.roleId
      };
      this.userDlg = true;
      this.$nextTick(() => {
        if (this.$refs.userFormRef) this.$refs.userFormRef.clearValidate();
      });
    },
    onDialogClosed() {
      this.submitting = false;
      if (this.$refs.userFormRef) this.$refs.userFormRef.resetFields();
    },
    submitUser() {
      this.$refs.userFormRef.validate(async (ok) => {
        if (!ok) return;
        this.submitting = true;
        try {
          if (this.isEdit) {
            const body = {
              roleId: this.userForm.roleId,
              displayName: this.userForm.displayName != null ? this.userForm.displayName : ''
            };
            const p = this.userForm.password && String(this.userForm.password).trim();
            if (p) body.password = p;
            await http.patch(`/admin/platform-users/${this.userForm.id}`, body);
            this.$message.success('已保存');
          } else {
            await http.post('/admin/platform-users', {
              username: this.userForm.username.trim(),
              password: this.userForm.password,
              displayName: this.userForm.displayName ? this.userForm.displayName.trim() : undefined,
              roleId: this.userForm.roleId
            });
            this.$message.success('已创建');
          }
          this.userDlg = false;
          this.load();
        } catch (e) {
          this.$message.error((e && e.message) || '操作失败');
        } finally {
          this.submitting = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.toolbar {
  display: flex;
  gap: 8px;
  align-items: center;
}
</style>
